import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import {
  CustomFontFamily,
  FontFamiliesResponseV,
  FontFileResponse,
  FontFileResponseV,
  FontFamiliesResponse
} from "@/types/custom-fonts";
import { Either } from "fp-ts/lib/Either";
import { _Error } from "@/lib/wordpress/data";
import { fpJsonStringify } from "@/util/fp-json-stringify";

export async function saveFontFile(
  fontFile: File
): Promise<Either<_Error[], FontFileResponse>> {
  return await makeWordPressAjaxRequest({
    action: "breakdance_save_font_file",
    dataToPost: { file: fontFile },
    decoder: FontFileResponseV
  });
}

export async function getFontFamiliesFromCssFile(
  cssUrl: string
): Promise<Either<_Error[], FontFamiliesResponse>> {
  return await makeWordPressAjaxRequest({
    action: "breakdance_get_font_families_from_css_file",
    dataToPost: { cssUrl },
    decoder: FontFamiliesResponseV
  });
}

export async function sendFontsToBackend(
  customFontFamilies: CustomFontFamily[]
): Promise<Either<_Error[], FontFamiliesResponse>> {
  return await makeWordPressAjaxRequest({
    action: "breakdance_save_font_families",
    dataToPost: {
      customFontFamilies: fpJsonStringify(customFontFamilies)
    },
    decoder: FontFamiliesResponseV
  });
}
